import React, { useEffect } from "react";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  useJsApiLoader,
} from "@react-google-maps/api";
import VehicleGaugePopup from "../common/VehicleGaugePopup";
import { mapApiKey } from "../../../const";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const center = {
  lat: 7.8731,
  lng: 80.7718,
};

const API_KEY = mapApiKey;
const LIBRARIES = ["places"]; // ✅ Defined once and reused

const FleetDashboardMap = ({
  vehicles,
  popupVehicle,
  setPopupVehicle,
  selectedVehicle,
  setSelectedVehicle,
  onMarkerInfoClick,
}) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: API_KEY,
    libraries: LIBRARIES,
  });

  const handleMarkerClick = (vehicle) => {
    setPopupVehicle((prev) =>
      prev?.vehicleNo === vehicle.vehicleNo ? null : vehicle,
    );
    if (popupVehicle && selectedVehicle) {
      setPopupVehicle(null);
      setSelectedVehicle(null);
    }
  };

  const handleInfoClick = (vehicle) => {
    if (onMarkerInfoClick) {
      onMarkerInfoClick(vehicle);
    }
    setPopupVehicle(null); // close popup only
  };

  useEffect(() => {
    if (selectedVehicle) {
      console.log("this is in the map: ", selectedVehicle);
    }
  }, []);

  if (!isLoaded) {
    return <div>Loading map...</div>;
  }

  const getMapCenter = () => {
    if (selectedVehicle) {
      return {
        lat: selectedVehicle.lat || selectedVehicle.latitude,
        lng: selectedVehicle.lng || selectedVehicle.longitude,
      };
    } else if (vehicles.length > 0) {
      // Compute average lat/lng of all vehicles
      const avgLat =
        vehicles.reduce((sum, v) => sum + v.lat, 0) / vehicles.length;
      const avgLng =
        vehicles.reduce((sum, v) => sum + v.lng, 0) / vehicles.length;
      return { lat: avgLat, lng: avgLng };
    } else {
      return center; // Fallback to Sri Lanka
    }
  };

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={getMapCenter()}
      zoom={selectedVehicle ? 15 : 7}
      options={{
        gestureHandling: "greedy",
        disableDefaultUI: false,
      }}
    >
      {vehicles.map((vehicle) => (
        <Marker
          key={vehicle.vehicleNo}
          position={{ lat: vehicle.lat, lng: vehicle.lng }}
          onClick={() => handleMarkerClick(vehicle)}
          icon={{
            url: "https://img.icons8.com/color/48/truck.png",
            scaledSize: new window.google.maps.Size(32, 32),
            rotation: vehicle.direction,
          }}
        />
      ))}

      {/* Show InfoWindow only if a popupVehicle exists and NO selectedVehicle */}
      {popupVehicle && !selectedVehicle && (
        <InfoWindow
          position={{ lat: popupVehicle.lat, lng: popupVehicle.lng }}
          onCloseClick={() => setPopupVehicle(null)} // ✅
          options={{ headerDisabled: true }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "320px",
              minWidth: "100px",
              padding: 10,
              boxSizing: "border-box",
              overflow: "hidden",
            }}
          >
            <VehicleGaugePopup
              vehicle={popupVehicle}
              onInfoClick={() => handleInfoClick(popupVehicle)}
              onClose={() => setPopupVehicle(null)}
            />
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
};

export default FleetDashboardMap;
